module.exports = __webpack_public_path__ + "static/media/USDT-AVAX.5ff35329.png";